export interface Entity {
  id: string
  name: string
  code: string
}

export interface Site {
  id: string
  name: string
  code: string
  entityId: string
}

export const mockEntities: Entity[] = [
  {
    id: 'entity-1',
    name: 'ACME Corporation',
    code: 'ACME',
  },
  {
    id: 'entity-2',
    name: 'TechCorp Industries',
    code: 'TECH',
  },
  {
    id: 'entity-3',
    name: 'Global Services Ltd',
    code: 'GLOBAL',
  },
]

export const mockSites: Site[] = [
  {
    id: 'site-1',
    name: 'Sydney Office',
    code: 'SYD',
    entityId: 'entity-1',
  },
  {
    id: 'site-2',
    name: 'Melbourne Office',
    code: 'MEL',
    entityId: 'entity-1',
  },
  {
    id: 'site-3',
    name: 'Brisbane Office',
    code: 'BNE',
    entityId: 'entity-2',
  },
  {
    id: 'site-4',
    name: 'Perth Office',
    code: 'PER',
    entityId: 'entity-2',
  },
  {
    id: 'site-5',
    name: 'Adelaide Office',
    code: 'ADL',
    entityId: 'entity-3',
  },
]
